export default "__VITE_ASSET__CJC9rSin__"